'use client'

import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useRouter, useSearchParams } from 'next/navigation'
import { useState, useEffect } from 'react'
import useDebounce from '@/useDebounce'

export const SearchBoxClient = ({ initialQuery }: SearchBoxClientProps) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const [searchTerm, setSearchTerm] = useState(initialQuery)
  const debouncedSearchTerm = useDebounce(searchTerm, 500)

  useEffect(() => {
    if (debouncedSearchTerm !== initialQuery) {
      const params = new URLSearchParams(searchParams.toString())
      if (debouncedSearchTerm) {
        params.set('query', debouncedSearchTerm)
      } else {
        params.delete('query')
      }
      params.set('page', '1') // Reset to page 1
      router.push(`/blog/search?${params.toString()}`)
    }
  }, [debouncedSearchTerm, initialQuery, searchParams, router])

  return (
    <div className="flex-1">
      <label htmlFor="searchTerm" className="sr-only">
        Search blog
      </label>
      <p className="hidden md:block text-sm text-gray-500 mb-1">Search</p>
      <div className="relative rounded-md shadow-xs">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <MagnifyingGlassIcon
            aria-hidden="true"
            className="size-5 text-gray-400"
          />
        </div>
        <input
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          id="searchTerm"
          type="text"
          placeholder="Search blog posts..."
          className="block w-full rounded-md border-0 py-2.5 pl-10 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-vi-gray sm:text-lg/6"
        />
        {searchTerm && (
          <button
            type="button"
            onClick={() => setSearchTerm('')}
            className="absolute inset-y-0 right-0 flex items-center pr-3"
          >
            <XMarkIcon
              className="size-4 text-gray-400 hover:text-gray-500"
              aria-hidden="true"
            />
          </button>
        )}
      </div>
    </div>
  )
}

interface SearchBoxClientProps {
  initialQuery: string
}

